export default __webpack_public_path__ + "a3c85b181e60a3f56db68b33cb7f7e16.svg";